import React from 'react'
import Footer from './Footer'
import Header from './Header'

const  Privacy = () => {
  return (
    <div>
    <Header/>
         
  <section class="bg-gradient-to-br from-brand to-brand-dark text-gray-700 mt-20">
    <div class="max-w-6xl mx-auto px-6 py-14">
      <p class="uppercase tracking-widest text-brand-light/90 text-xs font-semibold mb-3">Data Protection</p>

      <div className='w-full h-24 flex-row justify-between flex mt-12'>
            <h1 class="text-3xl sm:text-4xl font-extrabold leading-tight ">Privacy Policy</h1>
      

         <div class="size-10 rounded-full bg-gray-500 flex items-center justify-center  hover:bg-primary/20 hover:text-primary transition-all cursor-pointer" title='Beeppee Tracking & Consent Policy'>
          <span class="material-symbols-outlined" style={{ color: 'white' }}>download</span>
         </div>
      </div>
    

      <p class="mt-4 max-w-2xl text-slate/85 text-sm sm:text-base">
        This Policy explains how Beeppee collects, uses, stores, shares and protects personal information —
        including Location Information — when you use Beeppee.
      </p>
      <div class="mt-6 flex flex-wrap gap-4 text-sm text-grey/90">
        <div><span class="font-semibold text-grey">Effective Date:</span> 13/10/2026</div>
        <div><span class="font-semibold text-grey">Last Updated:</span> 13/10/2026</div>
      </div>
    </div>
  </section>
 
  
  <section class="bg-white border-b border-slate-200">
    <div class="max-w-6xl mx-auto px-6 py-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Registered Company</p>
        <p class="font-medium text-slate-800">Beeppoint solutions limited.</p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">CAC Registration No.</p>
        <p class="font-medium text-slate-800">RC:2015999</p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Trading Name</p>
        <p class="font-medium text-slate-800">Beeppee</p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Registered Address</p>
        <p class="font-medium text-slate-800"></p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Privacy Contact</p>
        <p class="font-medium text-slate-800">info@beeppee.com</p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Telephone</p>
        <p class="font-medium text-slate-800">+234 916 338 5136</p>
      </div>
      <div class="sm:col-span-2 lg:col-span-2">
        <p class="text-slate-400 text-xs uppercase tracking-wide">Data Protection Contact / DPO</p>
        <p class="font-medium text-slate-800">[Insert name / email, if applicable]</p>
      </div>
    </div>
  </section>
 
  
  <div class="max-w-6xl mx-auto px-6 py-10 flex flex-col lg:flex-row gap-10">
 
    
    <aside class="lg:w-72 shrink-0">
      <div class="lg:sticky lg:top-24 bg-white border border-slate-200 rounded-2xl p-5 max-h-[75vh] overflow-y-auto">
        <p class="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-3">Table of Contents</p>
        <nav class="space-y-1 text-sm" id="toc"></nav>
      </div>
    </aside>

    <main class="flex-1 min-w-0 space-y-10">
 
  
      <section id="s1" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">1. About This Policy</h2>
        <div class="space-y-2 text-sm text-slate-700 leading-relaxed">
          <p>Beeppee respects your privacy.</p>
          <p>This Privacy Policy explains how Beeppee collects, uses, stores, shares and protects personal information when you use Beeppee.</p>
          <p>Because Beeppee provides location and monitoring services, Location Information and movement information may be an important part of our processing.</p>
          <p>This Policy should be read with the Beeppee Terms &amp; Conditions and Tracking &amp; Consent Policy.</p>
        </div>
      </section>
 
  
      <section id="s2" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">2. Who Is Responsible for Your Data</h2>
        <div class="grid sm:grid-cols-2 gap-3 mb-4">
          <div class="bg-slate-50 rounded-lg p-3 text-sm"><span class="text-slate-400 text-xs uppercase block">Data Controller / Responsible Entity</span><span class="font-medium text-slate-800">[Insert legal entity]</span></div>
          <div class="bg-slate-50 rounded-lg p-3 text-sm"><span class="text-slate-400 text-xs uppercase block">Trading Name</span><span class="font-medium text-slate-800">Beeppee</span></div>
          <div class="bg-slate-50 rounded-lg p-3 text-sm"><span class="text-slate-400 text-xs uppercase block">Address</span><span class="font-medium text-slate-800">[Insert]</span></div>
          <div class="bg-slate-50 rounded-lg p-3 text-sm"><span class="text-slate-400 text-xs uppercase block">Email</span><span class="font-medium text-slate-800">info@beeppee.com</span></div>
          <div class="bg-slate-50 rounded-lg p-3 text-sm sm:col-span-2"><span class="text-slate-400 text-xs uppercase block">Telephone</span><span class="font-medium text-slate-800">+234 916 338 5136</span></div>
        </div>
        <p class="text-sm text-slate-700 mb-2">Where Beeppee determines why and how personal information is processed, Beeppee may act as a data controller or equivalent responsible entity.</p>
        <p class="text-sm text-slate-700">Where Beeppee processes information solely on behalf of a Business User, Beeppee may act as a data processor or service provider, depending on the circumstances.</p>
      </section>
 
  
      <section id="s3" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">3. Scope</h2>
        <p class="text-sm text-slate-700 mb-3">This Policy applies to information processed through:</p>
        <div class="flex flex-wrap gap-2 mb-4">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">The Beeppee mobile application</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Beeppee websites</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Tracking and monitoring services</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Geofencing</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Logistics and mobility features</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Panic Alerts</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Customer support</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Payment processes</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Partner integrations</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Related Services</span>
        </div>
        <p class="text-sm text-slate-700">Third-party services may have separate privacy policies.</p>
      </section>
 
  
      <section id="s4" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">4. What Personal Information We Collect</h2>
        <p class="text-sm text-slate-700 mb-4">Depending on your use of Beeppee, we may collect:</p>
        <div class="grid sm:grid-cols-3 gap-4">
          <div class="bg-indigo-50 rounded-xl p-4">
            <p class="font-semibold text-sm text-brand-dark mb-2">Account information</p>
            <ul class="list-disc list-outside pl-4 space-y-1 text-sm text-slate-700">
              <li>Name</li><li>Phone number</li><li>Email</li><li>Date of birth</li><li>Account identifiers</li><li>Authentication information</li><li>Preferences</li>
            </ul>
          </div>
          <div class="bg-indigo-50 rounded-xl p-4">
            <p class="font-semibold text-sm text-brand-dark mb-2">Service information</p>
            <ul class="list-disc list-outside pl-4 space-y-1 text-sm text-slate-700">
              <li>Vehicles</li><li>Assets</li><li>Trip information</li><li>Geofence settings</li><li>Alert settings</li><li>Emergency contacts</li><li>Service requests</li><li>Transaction information</li>
            </ul>
          </div>
          <div class="bg-indigo-50 rounded-xl p-4">
            <p class="font-semibold text-sm text-brand-dark mb-2">Technical information</p>
            <ul class="list-disc list-outside pl-4 space-y-1 text-sm text-slate-700">
              <li>Device type</li><li>Operating system</li><li>Application version</li><li>Device identifiers</li><li>IP address</li><li>Network information</li><li>Diagnostic information</li><li>Crash information</li><li>Security logs</li>
            </ul>
          </div>
        </div>
      </section>
 
  
      <section id="s5" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">5. Location and Movement Information</h2>
        <p class="text-sm text-slate-700 mb-3">Depending on permissions and features, Beeppee may process:</p>
        <div class="flex flex-wrap gap-2 mb-4">
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">Current location</span>
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">Previous location</span>
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">Location history</span>
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">GPS coordinates</span>
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">Routes</span>
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">Trips</span>
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">Movement</span>
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">Geofence events</span>
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">Estimated location</span>
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">Vehicle location</span>
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">Asset location</span>
          <span class="text-xs bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full">Location shared through Beeppee</span>
        </div>
        <p class="text-sm text-slate-700">Location data may be obtained from Devices, connected trackers, network information or other permitted sources.</p>
      </section>
 
  
      <section id="s6" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">6. Device and Technical Information</h2>
        <p class="text-sm text-slate-700 mb-3">We may process:</p>
        <div class="flex flex-wrap gap-2">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Device model</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Operating system</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Application version</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Device identifiers</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">IP address</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Network information</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Connectivity</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Battery-related information</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Crash reports</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Diagnostic information</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Performance information</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Security information</span>
        </div>
      </section>
 
  
      <section id="s7" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">7. Vehicle, Asset and Tracking Information</h2>
        <p class="text-sm text-slate-700 mb-3">If you use Beeppee to monitor a vehicle or asset, we may process:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700 mb-3">
          <li>Registration information</li>
          <li>Tracker identifiers</li>
          <li>Location</li>
          <li>Movement</li>
          <li>Trip history</li>
          <li>Geofence activity</li>
          <li>Alerts</li>
          <li>Device status</li>
          <li>Other information needed to provide the service</li>
        </ul>
        <p class="text-sm text-slate-700 bg-amber-50 border border-amber-200 rounded-lg p-3">Users must only track vehicles and assets lawfully.</p>
      </section>
 
  
      <section id="s8" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">8. Information About Other People</h2>
        <p class="text-sm text-slate-700 mb-2">If you invite, track, share a trip with or otherwise interact with another person through Beeppee, we may process information relating to that person.</p>
        <p class="text-sm text-slate-700">You are responsible for ensuring that you have appropriate authorization or lawful basis where required.</p>
      </section>
 
  
      <section id="s9" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">9. Audio and Generated Media</h2>
        <p class="text-sm text-slate-700 mb-2">Beeppee may generate audio or other media from information used by certain features.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">Generated media may use:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Event information</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Alert information</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Instructions</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Schedules</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Tracking events</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Other necessary inputs</span>
        </div>
        <p class="text-sm text-slate-700">If future versions permit user-uploaded media, this Policy may be updated.</p>
      </section>
 
    
      <section id="s10" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">10. Payment and Transaction Information</h2>
        <p class="text-sm font-medium text-slate-800 mb-2">Beeppee may process:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700 mb-3">
          <li>Transaction amounts</li>
          <li>Transaction dates</li>
          <li>Credits purchased or used</li>
          <li>Service purchases</li>
          <li>Transaction status</li>
          <li>Refund information</li>
        </ul>
        <p class="text-sm text-slate-700 mb-2">Payments may be processed by Flutterwave or another payment provider.</p>
        <p class="text-sm text-slate-700">Where payment-card information is handled by the payment provider, Beeppee may not receive or store the complete card information.</p>
      </section>
 
    
      <section id="s11" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">11. Information From Third Parties</h2>
        <p class="text-sm text-slate-700 mb-3">We may receive information from:</p>
        <div class="flex flex-wrap gap-2">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Payment providers</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Telecommunications providers</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Mapping services</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Logistics providers</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Ride-hailing providers</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Security providers</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Franchisees</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Business Users</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Authentication providers</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Technology providers</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Fraud-prevention providers</span>
        </div>
      </section>
 
    
      <section id="s12" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">12. Information We Derive</h2>
        <p class="text-sm text-slate-700 mb-3">We may generate information such as:</p>
        <div class="flex flex-wrap gap-2">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Geofence status</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Trip status</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Alert status</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Service usage information</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Technical diagnostics</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Security indicators</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Aggregated statistics</span>
        </div>
      </section>
 
    
      <section id="s13" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">13. How We Use Personal Information</h2>
        <p class="text-sm text-slate-700 mb-3">We may use information to:</p>
        <div class="grid sm:grid-cols-2 gap-2">
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Provide tracking</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Display locations</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Generate alerts</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Operate Geofences</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Facilitate trips</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Facilitate logistics</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Provide smart mobility</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Generate AI-powered events</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Provide customer support</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Process payments</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Prevent fraud</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Secure Accounts</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Improve Services</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Develop new features</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Communicate with users</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Comply with law</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Establish or defend legal claims</div>
        </div>
      </section>
 
    
      <section id="s14" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">14. Lawful Bases for Processing</h2>
        <p class="text-sm text-slate-700 mb-3">Depending on the circumstances, Beeppee may process personal information based on a lawful basis available under applicable Nigerian data-protection law, including:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-indigo-50 text-brand-dark border border-indigo-100 px-3 py-1 rounded-full">Contract</span>
          <span class="text-xs bg-indigo-50 text-brand-dark border border-indigo-100 px-3 py-1 rounded-full">Consent</span>
          <span class="text-xs bg-indigo-50 text-brand-dark border border-indigo-100 px-3 py-1 rounded-full">Legal obligation</span>
          <span class="text-xs bg-indigo-50 text-brand-dark border border-indigo-100 px-3 py-1 rounded-full">Protection of vital interests</span>
          <span class="text-xs bg-indigo-50 text-brand-dark border border-indigo-100 px-3 py-1 rounded-full">Legitimate interests where legally available</span>
          <span class="text-xs bg-indigo-50 text-brand-dark border border-indigo-100 px-3 py-1 rounded-full">Another lawful basis recognized by law</span>
        </div>
        <p class="text-sm text-slate-700">Where consent is required, Beeppee will seek it appropriately.</p>
      </section>
 
    
      <section id="s15" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">15. Location Permissions</h2>
        <p class="text-sm text-slate-700 mb-2">Certain features require device permissions. These may include:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Location</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Background location</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Notifications</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Bluetooth</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Microphone</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Camera</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Other permissions</span>
        </div>
        <p class="text-sm text-slate-700 mb-2">You can manage permissions through your Device settings.</p>
        <p class="text-sm text-slate-700">Disabling a required permission may prevent a feature from functioning.</p>
      </section>
 
    
      <section id="s16" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">16. Tracking Other People</h2>
        <p class="text-sm text-slate-700 mb-2">Beeppee does not authorize unlawful tracking.</p>
        <p class="text-sm text-slate-700 mb-2">A user who tracks another person is responsible for ensuring that the tracking is lawful and that any required consent, notice or other legal requirement has been satisfied.</p>
        <p class="text-sm text-slate-700">Detailed requirements are contained in the Tracking &amp; Consent Policy.</p>
      </section>
 
    
      <section id="s17" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">17. Children and Minors</h2>
        <div class="space-y-2 text-sm text-slate-700 leading-relaxed mb-3">
          <p>Beeppee is available to persons aged 18 and above, subject to applicable law.</p>
          <p>Because location information can be particularly sensitive, Beeppee may apply additional safeguards to minors.</p>
          <p>Where consent is the lawful basis for processing a minor's information and applicable law requires parental or guardian consent, Beeppee will require the appropriate authorization.</p>
          <p>Beeppee may use reasonable age and consent verification mechanisms.</p>
        </div>
        <div class="bg-indigo-50 rounded-lg p-3 text-sm text-brand-dark">
          Parents or guardians may contact <span class="font-semibold">info@beeppee.com</span> with concerns regarding a minor's information.
        </div>
      </section>
 
    
      <section id="s18" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">18. Sharing Personal Information</h2>
        <p class="text-sm text-slate-700 mb-3">We may share information:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700">
          <li>With people you choose through sharing features</li>
          <li>With service providers</li>
          <li>With logistics and mobility providers</li>
          <li>With Business Users where appropriate</li>
          <li>With payment providers</li>
          <li>With technology providers</li>
          <li>Where required by law</li>
          <li>Where necessary to protect rights or safety</li>
          <li>As part of a lawful corporate transaction</li>
        </ul>
      </section>
 
    
      <section id="s19" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">19. Service Providers</h2>
        <p class="text-sm text-slate-700 mb-3">Service providers may support:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Hosting</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Cloud infrastructure</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Payment processing</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Analytics</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Mapping</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Notifications</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Authentication</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">AI functionality</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Cybersecurity</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Customer support</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Other technical operations</span>
        </div>
        <p class="text-sm text-slate-700">Service providers should process information according to their contractual obligations and applicable law.</p>
      </section>
 
    
      <section id="s20" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">20. Partners and Business Users</h2>
        <div class="space-y-2 text-sm text-slate-700 leading-relaxed">
          <p>A partner may receive information necessary to provide a service you request.</p>
          <p>Business Users may independently determine the purposes for which certain employee, driver, fleet or customer information is processed.</p>
          <p>Business Users are responsible for providing required notices, establishing lawful bases and complying with applicable law.</p>
        </div>
      </section>
 
    
      <section id="s21" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">21. Law Enforcement and Emergency Requests</h2>
        <div class="space-y-2 text-sm text-slate-700 leading-relaxed">
          <p>Beeppee may disclose information where required or permitted by law, including pursuant to valid legal process.</p>
          <p>Where legally permitted and reasonably necessary, information may also be disclosed in response to an apparent serious threat to life or safety.</p>
          <p class="bg-amber-50 border border-amber-200 rounded-lg p-3">Beeppee does not independently guarantee emergency response.</p>
        </div>
      </section>
 
    
      <section id="s22" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">22. International Transfers</h2>
        <div class="space-y-2 text-sm text-slate-700 leading-relaxed">
          <p>Beeppee may use service providers located outside Nigeria.</p>
          <p>Where personal information is transferred internationally, Beeppee will implement applicable legal safeguards and comply with Nigerian data-protection requirements concerning international transfers.</p>
          <p>As Beeppee expands globally, regional privacy notices may be introduced.</p>
        </div>
      </section>
 
    
      <section id="s23" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">23. Data Retention</h2>
        <p class="text-sm text-slate-700 mb-2">Beeppee retains information only for as long as reasonably necessary for the purposes for which it was collected or as required or permitted by law.</p>
        <p class="text-sm text-slate-700 mb-4">Different categories may have different retention periods.</p>
        <p class="text-sm font-semibold text-slate-800 mb-2">Proposed retention schedule</p>
        <div class="overflow-x-auto">
          <table class="w-full text-sm border border-slate-200 rounded-lg overflow-hidden">
            <tbody class="divide-y divide-slate-100">
              <tr class="bg-slate-50"><td class="px-4 py-2 font-medium text-slate-700 w-1/2">Account information</td><td class="px-4 py-2 text-slate-500">[Insert period]</td></tr>
              <tr><td class="px-4 py-2 font-medium text-slate-700">Location history</td><td class="px-4 py-2 text-slate-500">[Insert period]</td></tr>
              <tr class="bg-slate-50"><td class="px-4 py-2 font-medium text-slate-700">Trip information</td><td class="px-4 py-2 text-slate-500">[Insert period]</td></tr>
              <tr><td class="px-4 py-2 font-medium text-slate-700">Panic/emergency records</td><td class="px-4 py-2 text-slate-500">[Insert period]</td></tr>
              <tr class="bg-slate-50"><td class="px-4 py-2 font-medium text-slate-700">Transaction records</td><td class="px-4 py-2 text-slate-500">[Insert period]</td></tr>
              <tr><td class="px-4 py-2 font-medium text-slate-700">Security/fraud records</td><td class="px-4 py-2 text-slate-500">[Insert period]</td></tr>
              <tr class="bg-slate-50"><td class="px-4 py-2 font-medium text-slate-700">Customer-support records</td><td class="px-4 py-2 text-slate-500">[Insert period]</td></tr>
            </tbody>
          </table>
        </div>
        <p class="text-xs text-slate-500 mt-3">These periods should be finalized following Beeppee's operational and legal retention assessment.</p>
      </section>
 
    
      <section id="s24" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">24. Account Deactivation and Deletion</h2>
        <p class="text-sm text-slate-700 mb-2">Users may deactivate their Accounts through the application where the functionality is available.</p>
        <p class="text-sm text-slate-700 mb-3">Deactivation does not necessarily result in immediate deletion of every record. Information may be retained where required or permitted for:</p>
        <div class="flex flex-wrap gap-2">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Legal compliance</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Fraud prevention</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Accounting</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Security</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Dispute resolution</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Regulatory requirements</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Other lawful purposes</span>
        </div>
      </section>
 
    
      <section id="s25" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">25. Your Privacy Rights</h2>
        <p class="text-sm text-slate-700 mb-3">Subject to applicable law, you may have rights to:</p>
        <div class="grid sm:grid-cols-2 gap-2 mb-4">
          <div class="bg-indigo-50 rounded-lg px-3 py-2 text-sm text-brand-dark">Access your information</div>
          <div class="bg-indigo-50 rounded-lg px-3 py-2 text-sm text-brand-dark">Request correction</div>
          <div class="bg-indigo-50 rounded-lg px-3 py-2 text-sm text-brand-dark">Request deletion</div>
          <div class="bg-indigo-50 rounded-lg px-3 py-2 text-sm text-brand-dark">Request restriction</div>
          <div class="bg-indigo-50 rounded-lg px-3 py-2 text-sm text-brand-dark">Object to processing</div>
          <div class="bg-indigo-50 rounded-lg px-3 py-2 text-sm text-brand-dark">Withdraw consent where applicable</div>
          <div class="bg-indigo-50 rounded-lg px-3 py-2 text-sm text-brand-dark">Receive information about processing</div>
          <div class="bg-indigo-50 rounded-lg px-3 py-2 text-sm text-brand-dark">Exercise rights on automated decisions</div>
          <div class="bg-indigo-50 rounded-lg px-3 py-2 text-sm text-brand-dark sm:col-span-2">Lodge a complaint with a competent data-protection authority</div>
        </div>
        <p class="text-sm text-slate-700">Requests should be sent to <span class="font-semibold">info@beeppee.com</span>. Beeppee may take reasonable steps to verify identity.</p>
      </section>
 
    
      <section id="s26" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">26. Security</h2>
        <p class="text-sm text-slate-700 mb-3">Beeppee uses reasonable technical and organizational safeguards designed to protect personal information. Measures may include:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Authentication</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Access controls</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Encryption where appropriate</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Monitoring</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Logging</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Security testing</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Personnel controls</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Vendor controls</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Incident response</span>
        </div>
        <p class="text-sm text-slate-700">No digital system can guarantee absolute security.</p>
      </section>
 
    
      <section id="s27" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">27. Data Breach Response</h2>
        <p class="text-sm text-slate-700 mb-2">If Beeppee becomes aware of a personal-data breach, it will assess and respond in accordance with applicable law.</p>
        <p class="text-sm text-slate-700">Where notification to regulators or affected individuals is required, Beeppee will take reasonable steps to provide the required notification.</p>
      </section>
 
    
      <section id="s28" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">28. Cookies and Similar Technologies</h2>
        <p class="text-sm text-slate-700 mb-3">Where Beeppee operates websites or web-based Services, we may use cookies, SDKs, logs, analytics tools and similar technologies. These may support:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Functionality</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Security</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Preferences</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Analytics</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Performance</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Service improvement</span>
        </div>
        <p class="text-sm text-slate-700">Where consent is required, Beeppee will seek appropriate consent.</p>
      </section>
 
    
      <section id="s29" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">29. Analytics and De-identified Information</h2>
        <p class="text-sm text-slate-700 mb-3">Beeppee may use aggregated or de-identified information to:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700 mb-3">
          <li>Analyze usage</li>
          <li>Improve performance</li>
          <li>Understand service patterns</li>
          <li>Develop products</li>
          <li>Diagnose problems</li>
          <li>Conduct business analytics</li>
        </ul>
        <p class="text-sm text-slate-700">Where information is properly de-identified, it may no longer constitute personal information under applicable law.</p>
      </section>
 
    
      <section id="s30" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">30. Marketing</h2>
        <div class="space-y-2 text-sm text-slate-700 leading-relaxed">
          <p>Where permitted by law, Beeppee may send promotional communications.</p>
          <p>Where consent is required, appropriate consent will be obtained.</p>
          <p>Users may opt out of promotional communications.</p>
          <p>Service, security and transaction messages may continue where necessary.</p>
        </div>
      </section>
 
    
      <section id="s31" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">31. Third-Party Services</h2>
        <p class="text-sm text-slate-700 mb-2">Third-party services accessed through Beeppee may have independent privacy practices.</p>
        <p class="text-sm text-slate-700">Beeppee is not responsible for a third party's privacy practices where that third party independently controls the relevant processing.</p>
      </section>
 
    
      <section id="s32" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">32. Automated Processing and AI</h2>
        <p class="text-sm text-slate-700 mb-3">Beeppee may use automated systems and AI for:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Event scheduling</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Recommendations</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Classifications</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Alerts</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Summaries</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Generated media</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Service optimization</span>
        </div>
        <p class="text-sm text-slate-700 mb-2">AI output may be inaccurate.</p>
        <p class="text-sm text-slate-700">Where applicable law grants rights concerning solely automated decisions producing significant effects, Beeppee will provide applicable safeguards.</p>
      </section>
 
    
      <section id="s33" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">33. Complaints</h2>
        <p class="text-sm text-slate-700 mb-2">If you have a privacy concern, contact <span class="font-semibold">info@beeppee.com</span>.</p>
        <p class="text-sm text-slate-700 mb-2">Beeppee encourages users to contact us first so that we can investigate and attempt to resolve concerns.</p>
        <p class="text-sm text-slate-700">Nothing in this Policy limits a right to complain to the competent data-protection authority.</p>
      </section>
 
    
      <section id="s34" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">34. Changes to This Policy</h2>
        <div class="space-y-2 text-sm text-slate-700 leading-relaxed">
          <p>Beeppee may update this Policy.</p>
          <p>Material changes may be communicated through the application, website, email or another reasonable method.</p>
          <p>The effective date will be updated when changes are made.</p>
        </div>
      </section>
 
    
      <section id="s35" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">35. Contact Us</h2>
        <div class="grid sm:grid-cols-2 gap-4 text-sm">
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">Registered Company</p><p class="font-medium text-slate-800">[Insert CAC-registered name]</p></div>
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">CAC Number</p><p class="font-medium text-slate-800">[Insert]</p></div>
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">Registered Address</p><p class="font-medium text-slate-800">[Insert]</p></div>
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">Privacy Contact</p><p class="font-medium text-slate-800">info@beeppee.com</p></div>
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">Telephone</p><p class="font-medium text-slate-800">+234 916 338 5136</p></div>
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">DPO / Privacy Officer</p><p class="font-medium text-slate-800">[Insert, if applicable]</p></div>
        </div>
      </section>
 
      
      <div class="bg-slate-900 text-white rounded-2xl p-6 sm:p-8">
        <p class="text-xs uppercase tracking-widest text-indigo-300 font-semibold mb-2">A Note on Location Data</p>
        <p class="text-sm text-slate-200 leading-relaxed">
          Because Beeppee provides location and monitoring services, Location Information and movement
          information may be an important part of our processing. Please read this Policy together with the
          Beeppee Terms &amp; Conditions and Tracking &amp; Consent Policy.
        </p>
      </div>
  
      </main>
    </div>
  
        <Footer/>
    </div>
  )
}

export default Privacy
